import { Injectable } from '@angular/core';

import { GoogleMap } from '@lib/geo/google/map';

@Injectable({
  providedIn: 'root',
})
export class MapWeatherRadarService {
  private _map: GoogleMap;
  private _timestamps = [
    '900913-m50m',
    '900913-m45m',
    '900913-m40m',
    '900913-m35m',
    '900913-m30m',
    '900913-m25m',
    '900913-m20m',
    '900913-m15m',
    '900913-m10m',
    '900913-m05m',
    '900913',
  ];
  private _index = 0;
  private _radarInterval;

  public onMapLoaded(googleMap: GoogleMap): void {
    this._map = googleMap;
  }

  public addToMap(): void {
    this._index = 0;
    if (this._map) {
      this._radarInterval = setInterval(this._initRadar.bind(this), 500);
    }
  }

  public removeFromMap(): void {
    clearInterval(this._radarInterval);
    this._map.mapInstance.overlayMapTypes.clear();
  }

  private _initRadar(): void {
    const tileNEX = new google.maps.ImageMapType({
      getTileUrl: (tile, zoom) => {
        return `https://mesonet.agron.iastate.edu/cache/tile.py/1.0.0/nexrad-n0q-${
          this._timestamps[this._index]
        }/${zoom}/${tile.x}/${tile.y}.png`;
      },
      tileSize: new google.maps.Size(256, 256),
      opacity: 0.15,
      name: 'NEXRAD',
    });
    this._map.mapInstance.overlayMapTypes.setAt(0, tileNEX);

    this._index++;
    if (this._index > 10) {
      this._index = 0;
    }
  }
}
